import React from "react";

export function StudentWizardNav() {
  return (
    <div className="wizard-nav">
      <div className="wizard-steps">
        <button
          type="button"
          className="wizard-step" 
          data-wizard-type="step"
          style={{borderStyle: "none", flexBasis: "calc(20% - 0.20rem)"}}
        >
          <div className="wizard-wrapper">
            <div className="wizard-number">1</div>
            <div className="wizard-label">
              <div className="wizard-title">Temel Bilgiler</div>
            </div>
          </div>
        </button>
        <button 
          type="button"
          className="wizard-step" 
          data-wizard-type="step"
          style={{borderStyle: "none", flexBasis: "calc(20% - 0.20rem)"}}
        >
          <div className="wizard-wrapper">
            <div className="wizard-number">2</div>
            <div className="wizard-label">
              <div className="wizard-title">Baba Bilgileri</div>
            </div>
          </div>
        </button>
        <button
          type="button"
          className="wizard-step"
          data-wizard-type="step"
          style={{borderStyle: "none", flexBasis: "calc(20% - 0.20rem)"}}
        >
          <div className="wizard-wrapper">
            <div className="wizard-number">3</div>
              <div className="wizard-label">
                <div className="wizard-title">Anne Bilgileri</div>
              </div>
          </div>
        </button>
        <button
          type="button"
          className="wizard-step"
          data-wizard-type="step"
          style={{borderStyle: "none", flexBasis: "calc(20% - 0.20rem)"}}
        >
          <div className="wizard-wrapper">
            <div className="wizard-number">4</div>
            <div className="wizard-label">
              <div className="wizard-title">Veli Bilgileri</div>
            </div>
          </div>
        </button>
        <button 
          type="button"
          className="wizard-step"
          data-wizard-type="step"
          style={{borderStyle: "none", flexBasis: "calc(20% - 0.20rem)"}}
        >
          <div className="wizard-wrapper">
            <div className="wizard-number">5</div>
            <div className="wizard-label">
              <div className="wizard-title">Diğer Bilgiler</div>
            </div>
          </div>
        </button>
      </div>
    </div>          
  );
}